import { type RedirectEntry, RedirectEntryType } from "#shared/redirect-service-types";

export async function redirectLookup(resource: string, type: RedirectEntryType): Promise<RedirectEntry | undefined> {
  return await $fetch("/api/redirect-lookup", { query: { resource, type }});
}